import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { reportService } from "../../../Services/report.service";
import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "react-bootstrap";
import InvoicesList from "./InvoicesList";
import PaymentsList from "./PaymentList";
import PpList from "./PpList";
import TaxRatesList from "./TaxRatesList";
import UsersList from "./UsersList";
import PnList from "./PnList";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const ReportDetail = (props) => {
  let ic = props.obj;
  let tag = props.tags;
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [payments, setPayments] = useState([]);
  const [pp, setPp] = useState([]);
  const history = useHistory();
  const [key, setKey] = useState("invoices");

  const handleCancel = () => {
    history.push("/stores");
  };
  const handlePrint = (
    arrayInvoices,
    arrayPayments,
    arrayPp,
    arrayTaxRates,
    arrayPn,
    arrayUsers,
    date
  ) => {
    let dataArrayPdfInvoices = [];
    let dataArrayPdfPayments = [];
    let dataArrayPdfPp = [];
    let dataArrayPdfTaxRates = [];
    let dataArrayPdfPn = [];
    let dataArrayPdfUsers = [];

    var dataRowHeader = [];

    dataRowHeader.push(
      {
        text: translator("InvoiceConclCashBalancePDF-DocNum"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Issued"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Zki"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Jir"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Operator"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Amount"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      }
    );

    dataArrayPdfInvoices.push(dataRowHeader);
    arrayInvoices.forEach(function (sourceRow) {
      var dataRow = [];
      dataRow.push({
        text: `${sourceRow.documentNumber}/${sourceRow.storeTag}/${sourceRow.posTag}`,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: `${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
          timeZone: "Europe/Zagreb",
        }).format(new Date(sourceRow.issued))}`,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: sourceRow.zki,
        fontSize: 9,
        alignment: "left",
      });
      dataRow.push({
        text: sourceRow.jir,
        fontSize: 9,
        alignment: "left",
      });
      dataRow.push({
        text: "Operator 1",
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(sourceRow.issued),
        }).format(Number(sourceRow.payValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataArrayPdfInvoices.push(dataRow);
    });

    dataRowHeader = [];

    dataRowHeader.push(
      {
        text: translator("InvoiceConclCashBalancePDF-PayMethod"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-Amount"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      }
    );
    dataArrayPdfPayments.push(dataRowHeader);
    arrayPayments.forEach(function (sourceRow) {
      var dataRow = [];
      dataRow.push({
        text: sourceRow.paymentMethodName,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.amount)),
        fontSize: 10,
        alignment: "right",
      });

      dataArrayPdfPayments.push(dataRow);
    });
    dataRowHeader = [];

    dataRowHeader.push(
      {
        text: translator("InvoiceConclCashBalancePDF-ConsumptionTax"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-TotalAmount"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-TotalTax"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      }
    );
    dataArrayPdfPp.push(dataRowHeader);

    arrayPp.forEach(function (sourceRow) {
      var dataRow = [];
      dataRow.push({
        text: sourceRow.pp,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.totalGroupPayValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.totalGroupPPValue)),
        fontSize: 10,
        alignment: "right",
      });

      dataArrayPdfPp.push(dataRow);
    });

    dataRowHeader = [];

    dataRowHeader.push(
      {
        text: translator("InvoiceConclCashBalancePDF-TaxRateName"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-TaxRate"),
        fontSize: 12,
        alignment: "left",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-TotalAmount"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      },
      {
        text: translator("InvoiceConclCashBalancePDF-TotalTax"),
        fontSize: 12,
        alignment: "right",
        bold: true,
      }
    );
    dataArrayPdfTaxRates.push(dataRowHeader);
    arrayTaxRates.forEach(function (sourceRow) {
      var dataRow = [];
      dataRow.push({
        text: sourceRow.taxRateName,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: sourceRow.taxRate,
        fontSize: 10,
        alignment: "left",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.totalGroupPayValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.totalGroupTaxValue)),
        fontSize: 10,
        alignment: "right",
      });

      dataArrayPdfTaxRates.push(dataRow);
    });

    dataRowHeader = [];

    dataRowHeader.push({
      text: translator("InvCashBalance-Amount"),
      fontSize: 12,
      alignment: "right",
      bold: true,
    });

    dataArrayPdfPn.push(dataRowHeader);

    arrayPn.forEach(function (sourceRow) {
      var dataRow = [];

      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.amount)),
        fontSize: 10,
        alignment: "right",
      });

      dataArrayPdfPn.push(dataRow);
    });

    dataRowHeader = [];

    dataRowHeader.push({
      text: translator("InvoiceConclCashBalancePDF-Operator"),
      fontSize: 12,
      alignment: "left",
      bold: true,
    });

    dataRowHeader.push({
      text: translator("InvCashBalance-Amount"),
      fontSize: 12,
      alignment: "right",
      bold: true,
    });

    dataArrayPdfUsers.push(dataRowHeader);

    arrayUsers.forEach(function (sourceRow) {
      var dataRow = [];

      dataRow.push({
        text: sourceRow.userPrintName,
        fontSize: 10,
        alignment: "left",
      });

      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(date),
        }).format(Number(sourceRow.amount)),
        fontSize: 10,
        alignment: "right",
      });

      dataArrayPdfUsers.push(dataRow);
    });

    let dd = {
      info: {
        title: translator("InvoiceConclCashBalancePDF-ConclusionDetail"),
        author: "john doe",
        subject: translator("InvoiceConclCashBalancePDF-ConclusionDetail"),
      },
      // a string or { width: number, height: number }
      pageSize: "A4",
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: "landscape",
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 130, 15, 50],
      header: [
        {
          columns: [
            {
              image:
                "data:image/png;base64,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",
              width: 150,
              marginLeft: 0,
              marginTop: 0,
            },
            {
              text: [
                {
                  text: `${translator(
                    "InvoiceConclCashBalancePDF-ConclusionDetail"
                  )} \n\n`,
                  fontSize: 25,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 30,
                },
                {
                  text: `${translator("InvoiceCashBalancePDF-Date")} : `,
                  fontSize: 14,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 15,
                },
                {
                  text: `${new Intl.DateTimeFormat("hr", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    timeZone: "Europe/Zagreb",
                  }).format(new Date(ic.created))} \n\n`,
                  fontSize: 15,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 20,
                },
                {
                  text: `${translator("InvoiceCashBalancePDF-Tenant")} : `,
                  fontSize: 12,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 20,
                },
                {
                  text: `${tag.tenantName} \n\n`,
                  fontSize: 13,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 20,
                },
                {
                  text: `${
                    tag.posName
                      ? `${translator(
                          "InvoiceCashBalancePDF-BillingDevice"
                        )} : `
                      : ""
                  }`,
                  fontSize: 12,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 20,
                },
                {
                  text: `${tag.posName}\n\n`,
                  fontSize: 13,
                  bold: true,
                  alignment: "left",
                  letterSpacing: 10,
                  lineHeight: 0.5,
                  marginTop: 20,
                },
              ],
              //style: 'headerTextSmall',
              fontSize: 12,
              marginRight: 20,
              marginLeft: 20,
              marginTop: 25,
              bold: false,
              alignment: "right",
              color: "#333",
              height: 60,
              lineHeight: 0.7,
              letterSpacing: 50,
            },
          ],
        },
      ],
      content: [
        {
          columns: [
            {
              text: `${translator("InvoiceConclCashBalancePDF-DocNum")}: ${
                ic.docNumber
              }-${tag.storeName}-${tag.posName}`,
              fontSize: 18,
              bold: true,
              alignment: "left",
            },
          ],
          style: {
            marginBottom: 15,
          },
        },
        "\n\n",
        {
          columns: [
            {
              width: 90,
              text: `${translator("InvoiceConclusionDetail-Year")} : ${
                ic.year
              }`,
              fontSize: 12,
              bold: false,
              alignment: "left",
            },
            {
              width: 150,
              text: `${translator("Report-View-TableHeader-DocNumberFrom")} : ${
                ic.invoiceDocNumberFrom
              }`,
              fontSize: 12,
              bold: false,
              alignment: "left",
            },
            {
              width: 150,
              text: `${translator("Report-View-TableHeader-DocNumberTo")}: ${
                ic.invoiceDocNumberTo
              }`,
              fontSize: 12,
              bold: false,
              alignment: "left",
            },
            {
              width: "*",
              text: `${translator(
                "InvoiceConclCashBalancePDF-TotalAmount"
              )} : ${new Intl.NumberFormat("hr", {
                style: "currency",
                currency: activeCurrencyByDate(date),
              }).format(Number(ic.amount))}`,
              fontSize: 18,
              bold: true,
              alignment: "right",
            },
          ],
        },
        "\n\n",
        {
          text: translator("InvoiceConclCashBalancePDF-AccRecapitulation"),
          marginBottom: 20,
          marginTop: 10,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: [100, 100, "*", "*", "auto", 150],
            body: dataArrayPdfInvoices,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.5 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
        {
          text: translator(
            "InvoiceConclCashBalancePDF-PayMethodRecapitulation"
          ),
          marginBottom: 20,
          marginTop: 20,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: ["*", 150],
            body: dataArrayPdfPayments,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.2 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
        {
          text: translator(
            "InvoiceConclCashBalancePDF-ConsumptionTaxRecapitulation"
          ),
          marginBottom: 20,
          marginTop: 20,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: ["*", 150, 150],
            body: dataArrayPdfPp,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.2 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
        {
          text: translator("InvoiceConclCashBalancePDF-TaxRecapitulation"),
          marginBottom: 20,
          marginTop: 20,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: ["*", "*", 150, 150],
            body: dataArrayPdfTaxRates,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.2 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
        {
          text: translator("InvoiceConclCashBalancePDF-PpRecapitulation"),
          marginBottom: 20,
          marginTop: 20,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: [300],
            body: dataArrayPdfPn,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.2 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
        {
          text: translator("InvoiceConclCashBalancePDF-UserRecapitulation"),
          marginBottom: 20,
          marginTop: 20,
          fontSize: 20,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: [150, 150],
            body: dataArrayPdfUsers,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1.2
                : 1;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1.2 : 1;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? "#aaa"
                : "#aaa";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "#aaa"
                : "#aaa";
            },
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text:
                    `${translator("InvoiceCashBalancePDF-Page")} ` +
                    currentPage.toString() +
                    " / " +
                    pageCount,
                  alignment: "right",
                  style: "normalText",
                  fontSize: 10,
                  margin: [0, 20, 20, 0],
                },
              ],
            ],
          },
          layout: "noBorders",
        };
      },
    };

    pdfMake.createPdf(dd).open();
  };
  const exportFunction = () => {
    Promise.all([
      reportService.invoicesConclusionInvoices({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
      reportService.invoicesConclusionPayment({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
      reportService.invoicesConclusionPp({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
      reportService.invoicesConclusionTaxRates({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
      reportService.invoicesConclusionPn({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
      reportService.invoicesConclusionUsers({
        guid: ic.guid,
        pageIndex: 0,
        pageSize: 0,
      }),
    ]).then((values) => {
      handlePrint(
        values[0].data.data,
        values[1].data.data,
        values[2].data.data,
        values[3].data.data,
        values[4].data.data,
        values[5].data.data,
        ic.created
      );
    });
  };
  return (
    <CardWrap subtitle={translator("ReportDetail-ConclusionDetail")}>
      <div className="row pl-0">
        <div className="col-lg-3">
          <p style={{ fontSize: 15 }}>
            <table className="table">
              <tr>
                <th colspan="2" style={{ textAlign: "center" }}>
                  {translator("InvConlCashBalance-DateTime")}
                </th>
              </tr>
              <tr>
                <td colspan="2" style={{ textAlign: "center" }}>
                  {new Intl.DateTimeFormat("hr", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    hour12: false,
                    timeZone: "Europe/Zagreb",
                  }).format(new Date(ic.created))}
                </td>
              </tr>
              <tr>
                <th>{translator("InvConlCashBalance-SellingSpot")}</th>
                <th>{translator("InvConlCashBalance-PosTag")}</th>
              </tr>
              <tr>
                <td>{tag.storeName}</td>
                <td>{tag.posName}</td>
              </tr>

              <tr>
                <th>{translator("Report-View-TableHeader-DocNumberFrom")}</th>
                <th>{translator("Report-View-TableHeader-DocNumberTo")}</th>
              </tr>
              <tr>
                <td>{ic.invoiceDocNumberFrom}</td>
                <td>{ic.invoiceDocNumberTo}</td>
              </tr>
              <tr className="footer-backgorund">
                <th>{translator("InvoiceConclusionDetail-Total")}</th>
                <th style={{ fontWeight: 600, fontSize: 16 }}>
                  {new Intl.NumberFormat("hr", {
                    style: "currency",
                    currency: activeCurrencyByDate(ic.created),
                  }).format(Number(ic.amount))}
                </th>
              </tr>
            </table>
            <hr />
          </p>
          <button
            onClick={exportFunction}
            className="btn btn-block btn-outline-secondary mb-2"
          >
            {translator("InvoiceConclusionDetail-DownloadDocument")}
          </button>
        </div>
        <div className="col-lg-9 border-left">
          <h2>{translator("DetailsTab-Recapitulations")} :</h2>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
              setKey(k);
            }}
            variant="tabs"
          >
            <Tab
              eventKey="invoices"
              title={translator("ReportDetail-NavTitle-Invoices")}
              tabClassName="mob-tabs"
            >
              <InvoicesList guid={ic.guid} date={ic.created} />
            </Tab>
            <Tab
              eventKey="payments"
              title={translator("ReportDetail-NavTitle-Payments")}
              tabClassName="mob-tabs"
            >
              <PaymentsList guid={ic.guid} date={ic.created} />
            </Tab>
            <Tab
              eventKey="pp"
              title={translator("ReportDetail-NavTitle-PP")}
              tabClassName="mob-tabs"
            >
              <PpList guid={ic.guid} date={ic.created} />
            </Tab>
            <Tab
              eventKey="taxRates"
              title={translator("ReportDetail-NavTitle-TaxRates")}
              tabClassName="mob-tabs"
            >
              <TaxRatesList guid={ic.guid} date={ic.created} />
            </Tab>
            <Tab
              eventKey="pn"
              title={translator("ReportDetail-NavTitle-Pn")}
              tabClassName="mob-tabs"
            >
              <PnList guid={ic.guid} date={ic.created} />
            </Tab>
            <Tab
              eventKey="users"
              title={translator("ReportDetail-NavTitle-Users")}
              tabClassName="mob-tabs"
            >
              <UsersList guid={ic.guid} date={ic.created} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </CardWrap>
  );
};

export default ReportDetail;
